<form [formGroup]="vForm">
  <p>
    <bb-input-checkbox-ui
      label="I agree with the Terms & Conditions"
      formControlName="inputCheckbox"
    ></bb-input-checkbox-ui>
  </p>
</form>
